
import React, { PropsWithChildren } from 'react';
import { transformHTMLParserLinks } from '../../../utils/rewriteLink/rewriteLink';
import './CardBenefitModal.css';
import { Image, Modal, Icon } from '../../../importCL';

/* eslint-disable */
enum Version {
    Icon = 'icon',
    Image = 'image'
}
/* eslint-enable */

interface IBenefitItem {
    title?: string;
    subTitle?: string;
    imgPath?: string;
    imgAltText?: string;
    iconUuid?: string;
    iconPath?: string;
    iconAltText?: string;
}

export interface ICardBenefitModalProps {
    modalIsOpen?: boolean
    setModalIsOpen?: React.Dispatch<React.SetStateAction<boolean>>
    benefitItem?: IBenefitItem;
    version?: Version;
}

export default function CardBenefitModal({
    modalIsOpen = false,
    setModalIsOpen,
    benefitItem,
    version = Version.Icon,
}: PropsWithChildren<ICardBenefitModalProps>): JSX.Element {
    return (
        <Modal isOpen={modalIsOpen} modalOpen={setModalIsOpen} className='CardBenefitModal'>
            <div className='CardBenefitModal__items'>
                { benefitItem && 
                    <div className='CardBenefitModal__picture'>
                        {   version === Version.Image ?
                            <Image loading='lazy' src={benefitItem.imgPath} alt={benefitItem.imgAltText} /> :
                            <Icon loading='lazy' alt={benefitItem.iconAltText} src={benefitItem.iconPath} /> 
                        }
                    </div>
                }
                { benefitItem && 
                    <div>
                        <div className='CardBenefitModal__title'> {transformHTMLParserLinks(benefitItem.title ? benefitItem.title : '')} </div>
                        <div> {transformHTMLParserLinks(benefitItem.subTitle ? benefitItem.subTitle : '')} </div>
                    </div>
                }
            </div>
        </Modal>
    );
}
        